import React from 'react';
import { MapPin, Clock, Info, Bike, ShoppingBag } from 'lucide-react';
import { Restaurant, RestaurantSettings } from '../../lib/types';
import { formatCurrency } from '../../lib/utils';
interface RestaurantHeaderProps {
  restaurant: Restaurant;
  settings: RestaurantSettings | null;
  zoneName?: string;
}
export function RestaurantHeader({
  restaurant,
  settings,
  zoneName
}: RestaurantHeaderProps) {
  return <div className="bg-[#0B0B0B] border-b border-white/10" data-id="element-917">
      {/* Cover Image */}
      <div className="relative h-44 sm:h-60 md:h-72 w-full bg-[#141414]" data-id="element-918">
        <img src={restaurant.cover_url || 'https://cdn.magicpatterns.com/uploads/rYDkPPUtvynEvWDL4HujUk/portada.png'} alt={restaurant.name} className="w-full h-full object-cover" data-id="element-919" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B] via-black/40 to-transparent" data-id="element-920" />

        {/* Badges */}
        <div className="absolute top-4 right-4 flex flex-col gap-2 items-end" data-id="element-921">
          {restaurant.is_featured && <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider bg-[#C9A34E] text-[#0B0B0B] shadow-lg" data-id="element-922">
              ★ Destacado
            </span>}
          {!restaurant.is_open && <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider bg-[#CE1126] text-white shadow-lg" data-id="element-923">
              Cerrado
            </span>}
        </div>
      </div>

      {/* Content */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-924">
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 sm:items-end -mt-10 sm:-mt-14 mb-5" data-id="element-925">
          {/* Logo */}
          <div className="relative w-20 h-20 sm:w-28 sm:h-28 rounded-2xl bg-[#0B0B0B] p-1 shadow-xl border border-white/10 shrink-0" data-id="element-926">
            {restaurant.logo_url ? <img src={restaurant.logo_url} alt={`${restaurant.name} logo`} className="w-full h-full rounded-xl object-cover" data-id="element-927" /> : <img src="https://cdn.magicpatterns.com/uploads/66K7i7HxpjApVZJyeR9rjp/ChatGPT_Image_15_mar_2026,_13_53_22.png" alt="NOIZA" className="w-full h-full rounded-xl object-cover" data-id="element-928" />}
          </div>

          {/* Title & Info */}
          <div className="flex-1 pb-2" data-id="element-929">
            <h1 className="text-2xl sm:text-4xl font-black text-white mb-1 tracking-tight" data-id="element-930">
              {restaurant.name}
            </h1>
            {restaurant.description_short && <p className="text-white/50 text-sm sm:text-base max-w-2xl mb-3" data-id="element-931">
                {restaurant.description_short}
              </p>}

            <div className="flex flex-wrap items-center gap-3 text-sm text-white/40 font-medium" data-id="element-932">
              {(zoneName || restaurant.address_text) && <div className="flex items-center gap-1.5" data-id="element-933">
                  <MapPin className="w-3.5 h-3.5" data-id="element-934" />
                  {zoneName || restaurant.address_text}
                </div>}

              {settings?.average_prep_time_minutes && <div className="flex items-center gap-1.5" data-id="element-935">
                  <Clock className="w-3.5 h-3.5" data-id="element-936" />
                  {settings.average_prep_time_minutes} min
                </div>}

              {settings?.minimum_order_amount != null && settings.minimum_order_amount > 0 && <div className="flex items-center gap-1.5" data-id="element-937">
                    <Info className="w-3.5 h-3.5" data-id="element-938" />
                    Mín. {formatCurrency(settings.minimum_order_amount)}
                  </div>}
            </div>
          </div>
        </div>

        {/* Order Methods — Mexican color gradient badges */}
        {settings && <div className="flex flex-wrap gap-2.5 pb-5" data-id="element-939">
            {settings.accept_delivery && <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-bold text-white border border-white/10" style={{
          background: 'linear-gradient(135deg, #006847 0%, #2AABB3 100%)'
        }} data-id="element-940">
                <Bike className="w-3.5 h-3.5" data-id="element-941" /> Delivery
              </span>}
            {settings.accept_pickup && <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-bold text-white border border-white/10" style={{
          background: 'linear-gradient(135deg, #CE1126 0%, #E8751A 100%)'
        }} data-id="element-942">
                <ShoppingBag className="w-3.5 h-3.5" data-id="element-943" /> Para llevar
              </span>}
          </div>}
      </div>
    </div>;
}